import * as React from 'react';
import type { FC } from 'react';
import { useState } from 'react';
import fetchAPI from 'app/helpers/fetch';
import { State, PENDING, REJECTED, FULFILLED } from 'admin-mojo/helpers/StateNotification';
import { useLocales } from '../../locales';

type ClaimProps = {
  hasCashback: boolean;
  onSuccess: () => void;
};

const useClaim = ({ onSuccess }: ClaimProps) => {
  const [state, setState] = useState<State>({ status: FULFILLED });

  const claim = () => {
    setState({ status: PENDING });

    fetchAPI(`/cashback_claims.json`, { method: 'POST', body: null })
      .then(() => {
        onSuccess();
        setState({ status: FULFILLED });
      })
      .catch((v) => {
        setState({ status: REJECTED, error: v });
      });
  };

  return [state, claim] as const;
};

const Claim: FC<ClaimProps> = (props) => {
  const [state, claim] = useClaim(props);
  const locales = useLocales();
  const enabled = props.hasCashback && state.status !== PENDING;

  return (
    <div className="xo-game-cashback_claim">
      <button className="xo-game-cashback_claim-button" type="button" onClick={() => claim()} disabled={!enabled}>
        {state.status === PENDING ? 'spinner' : locales('cashback.claim')}
      </button>
      {state.status === REJECTED ? <div>{state.error}</div> : <a href="/promo/cashback">{locales('cashback.rules')}</a>}
    </div>
  );
};

export default Claim;
